import React from 'react';
import { useSelector } from 'react-redux';
import './BottomBar.css';

function BottomBar() {
  const announcementMarquees = useSelector(
    (state) => state.homeState.announcementMarquees
  );
  const marquees = (announcementMarquees || []).filter(
    (text) => typeof text === 'string' && text.trim()
  );

  if (!marquees.length) {
    return null;
  }

  const marqueeText = marquees
    .map((text) => text.trim())
    .join('  |  ');

  return (
    <div className="bottombar">
      <div className="marquee">
        <div className="marquee-content">
          {marqueeText}
          &nbsp; | &nbsp;
          {marqueeText}
          &nbsp; | &nbsp;
        </div>
      </div>
    </div>
  );
}

export default BottomBar;
